var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      { // 100%
        translateX: 0,
        translateY: -_vm.windowHeight,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.sixthStepTriggerAtPoint + 2900,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth,
          translateY: _vm.windowHeight * 0.5 - (_vm.windowHeight * 0.4 / 2),
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        { // 100%
          translateX: -5500,
          translateY: _vm.windowHeight * 0.5 - (_vm.windowHeight * 0.4 / 2),
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 1000
        }
      ],"triggerAt":_vm.firstStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({'height': _vm.windowHeight * 0.3 + 'px'}),attrs:{"src":_vm.firstStep[0],"alt":"animated train coming from the rigth"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: _vm.windowWidth + 200,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: -200,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 200
        }
      ],"triggerAt":_vm.firstStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"bg-grey",style:({ width: (_vm.windowWidth + 400) + 'px', height: _vm.windowHeight + 'px', transform: 'skewX(-10deg)'})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: -_vm.windowWidth,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.secondStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .3,
            translateY: _vm.windowHeight * .15,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .3,
            translateY: _vm.windowHeight * .15,
            rotate: 1,
            scale: 1.5,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .15 + 'px'}),attrs:{"src":_vm.secondStep[0],"alt":"green logo 1"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .45,
            translateY: _vm.windowHeight * .09,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .45,
            translateY: _vm.windowHeight * .09,
            rotate: 1,
            scale: .75,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .15 + 'px'}),attrs:{"src":_vm.secondStep[0],"alt":"green logo 2"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .6,
            translateY: _vm.windowHeight * .2,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .6,
            translateY: _vm.windowHeight * .2,
            rotate: 1,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .15 + 'px'}),attrs:{"src":_vm.secondStep[0],"alt":"green logo 3"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .7,
            translateY: _vm.windowHeight * .05,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .7,
            translateY: _vm.windowHeight * .05,
            rotate: 1,
            scale: .25,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .15 + 'px'}),attrs:{"src":_vm.secondStep[0],"alt":"green logo 4"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 0,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.secondStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen"},[_c('img',{style:({height: _vm.windowHeight * .45 + 'px', margin: '0 auto'}),attrs:{"src":_vm.secondStep[1],"alt":"white shapes appearing from opacity 0 to 1"}})])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .2,
            translateY: _vm.windowHeight * .5,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 0,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .2,
            translateY: _vm.windowHeight * .5,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.secondStepTriggerAtPoint + 200,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen absolute"},[_c('h2',{staticStyle:{"color":"#ec6608","font-weight":"600","font-size":"45px"}},[_vm._v("Recycling")]),_c('p',{staticStyle:{"font-size":"24px","margin-bottom":"1rem"}},[_vm._v(" Whitemoor is our largest rail recycling plant. ")]),_c('p',{staticStyle:{"font-size":"24px","margin-bottom":"1rem"}},[_vm._v(" Every day, used ballast (the rocks that go under the tracks) "),_c('br'),_vm._v(" sleepers, steels, switches and crossings and rail arrive at the site. ")]),_c('p',{staticStyle:{"font-size":"24px","margin-bottom":"1rem"}},[_vm._v(" Materials are processed for reuse, or sold on - to the "),_c('br'),_vm._v(" construction industry for example - instead of going to landfill. ")])])])],1),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: -_vm.windowWidth,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.thirdStepTriggerAtPoint + 2400,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",staticStyle:{"transform-origin":"top left"},attrs:{"keyframes":[
          { // 0%
            translateX: -100,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 0,
            duration: 0
          },
          {
            translateX: -100,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 400,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-left bg-cover",style:({'background-image': ("url(" + (_vm.thirdStep[4]))})},[_c('div',{staticClass:"sr-only"},[_vm._v(" 40 to 100 wagons loaded with a varity of materials arrive each week. The materials are graded and sorted into what can be reused on the network and what can be sold. In 2016/17: ")])])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: .8,
            opacity: 0,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: .8,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 800,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-contain",style:({'background-image': ("url(" + (_vm.thirdStep[3]))})},[_c('div',{staticClass:"sr-only"},[_vm._v(" 1.26 millions ")])])]),_c('animate-x',{staticClass:"absolute z-10",staticStyle:{"transform-origin":"top left"},attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .34,
            translateY: _vm.windowHeight * .75,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 0,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .34,
            translateY: _vm.windowHeight * .75,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1000,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen font-bold"},[_c('p',{staticStyle:{"font-size":"30px","color":"#00983b"}},[_vm._v(" tonnes of ballast (or 15 Washington"),_c('br'),_vm._v(" Monuments' worth) were recycled."),_c('br'),_vm._v(" A saving of £6m! ")])])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .64,
            translateY: _vm.windowHeight * .64,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .64,
            translateY: _vm.windowHeight * .64,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .18 + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"ballast 1"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .73,
            translateY: _vm.windowHeight * .64,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .73,
            translateY: _vm.windowHeight * .64,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .18 + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"ballast 2"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .82,
            translateY: _vm.windowHeight * .64,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .82,
            translateY: _vm.windowHeight * .64,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .18 + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"ballast 3"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .64,
            translateY: _vm.windowHeight * .8,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .64,
            translateY: _vm.windowHeight * .8,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .18 + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"ballast 4"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .73,
            translateY: _vm.windowHeight * .8,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .73,
            translateY: _vm.windowHeight * .8,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .18 + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"ballast 5"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .82,
            translateY: _vm.windowHeight * .8,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .82,
            translateY: _vm.windowHeight * .8,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .18 + 'px'}),attrs:{"src":_vm.thirdStep[1],"alt":"ballast 6"}})]),_c('animate-x',{staticClass:"absolute w-screen",staticStyle:{"z-index":"-1"},attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1400,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth + 'px'}),attrs:{"src":_vm.thirdStep[2],"alt":"recycling logos"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * 0.03,
            translateY: _vm.windowHeight * .3,
            rotate: 0,
            scale: 0,
            opacity: 0,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * 0.03,
            translateY: _vm.windowHeight * .3,
            rotate: 0,
            scale: .9,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.thirdStepTriggerAtPoint + 1600,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowHeight * .4 + 'px'}),attrs:{"src":_vm.thirdStep[0],"alt":"obelisc"}})])],1),_c('animate-x',{staticClass:"absolute",staticStyle:{"width":"100%"},attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: -_vm.windowWidth,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fourthStepTriggerAtPoint + 1400,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute z-10",staticStyle:{"transform-origin":"top left"},attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth,
            translateY: 0,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 0,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .05,
            translateY: 0,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('p',{staticStyle:{"letter-spacing":"-20px","font-size":"330px","line-height":"450px","color":"#0098bd","font-weight":"bold"}},[_vm._v("93,000")])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 0,
            opacity: 0,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 200,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({ width: _vm.windowWidth + 'px'}),attrs:{"src":_vm.fourthStep[0],"alt":"background pattern"}})]),_c('animate-x',{staticClass:"absolute z-10",staticStyle:{"transform-origin":"top left"},attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * 0.05,
            translateY: _vm.windowHeight * .6,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 0,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * 0.05,
            translateY: _vm.windowHeight * .6,
            rotate: 0,
            scale: _vm.scaleFactorTxt,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 400,"deltaYcounter":_vm.deltaYcounter}},[_c('p',{staticClass:"w-screen font-bold",staticStyle:{"font-size":"30px","color":"#0098bd"}},[_vm._v(" Enough scrap metal to build 13"),_c('br'),_vm._v(" Eiffel Towers was recycled"),_c('br'),_vm._v(" nationally! A saving of just over"),_c('br'),_vm._v(" £20m! ")])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .4,
            translateY: _vm.windowHeight * .55,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .4,
            translateY: _vm.windowHeight * .55,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth * .12 + 'px'}),attrs:{"src":_vm.fourthStep[1],"alt":"bit of rail 1"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .5,
            translateY: _vm.windowHeight * .55,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .5,
            translateY: _vm.windowHeight * .55,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth * .12 + 'px'}),attrs:{"src":_vm.fourthStep[1],"alt":"bit of rail 2"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .6,
            translateY: _vm.windowHeight * .55,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .6,
            translateY: _vm.windowHeight * .55,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth * .12 + 'px'}),attrs:{"src":_vm.fourthStep[1],"alt":"bit of rail 3"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .4,
            translateY: _vm.windowHeight * .68,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .4,
            translateY: _vm.windowHeight * .68,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth * .12 + 'px'}),attrs:{"src":_vm.fourthStep[1],"alt":"bit of rail 4"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .5,
            translateY: _vm.windowHeight * .68,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .5,
            translateY: _vm.windowHeight * .68,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth * .12 + 'px'}),attrs:{"src":_vm.fourthStep[1],"alt":"bit of rail 5"}})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .6,
            translateY: _vm.windowHeight * .68,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .6,
            translateY: _vm.windowHeight * .68,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 600,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth * .12 + 'px'}),attrs:{"src":_vm.fourthStep[1],"alt":"bit of rail 6"}})]),_c('animate-x',{staticClass:"absolute z-10",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth * .72,
            translateY: _vm.windowHeight * .3,
            rotate: 0,
            scale: 0,
            opacity: 1,
            duration: 0
          },
          {
            translateX: _vm.windowWidth * .72,
            translateY: _vm.windowHeight * .3,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fourthStepTriggerAtPoint + 800,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({height: _vm.windowHeight * .6 + 'px'}),attrs:{"src":_vm.fourthStep[2],"alt":"Eiffel Tower"}})])],1),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: -_vm.windowWidth,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.fifthStepTriggerAtPoint + 1100,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: -_vm.windowHeight,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fifthStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-contain bg-no-repeat",style:({'background-image': ("url(" + (_vm.fifthStep[0]))})})]),_c('animate-x',{staticClass:"absolute z-20",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 0,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fifthStepTriggerAtPoint + 500,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-contain bg-no-repeat",style:({'background-image': ("url(" + (_vm.fifthStep[1]))})}),_c('p',{staticClass:"sr-only"},[_vm._v(" Recycling is so important to us, not only as a company but as a country too. ")])]),_c('animate-x',{staticClass:"absolute z-20",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 0,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fifthStepTriggerAtPoint + 500,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-contain bg-no-repeat",style:({'background-image': ("url(" + (_vm.fifthStep[2]))})}),_c('p',{staticClass:"sr-only"},[_vm._v(" To be able to reuse the materials that we recieve here, in the ways that we do, makes me feel incredibly proud to be part of the precess. ")])]),_c('animate-x',{staticClass:"position z-10",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 0,
            opacity: 0,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.fifthStepTriggerAtPoint + 400,"deltaYcounter":_vm.deltaYcounter}},[_c('img',{style:({width: _vm.windowWidth + 'px'}),attrs:{"src":_vm.fifthStep[3],"alt":"background shapes"}})])],1),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
        { // 0%
          translateX: 0,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 0
        },
        {
          translateX: -_vm.windowWidth,
          translateY: 0,
          rotate: 0,
          scale: 1,
          opacity: 1,
          duration: 500
        }
      ],"triggerAt":_vm.sixthStepTriggerAtPoint + 2400,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: _vm.windowHeight,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.sixthStepTriggerAtPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.sixthStep[0]))})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.sixthStepTriggerAtPoint + 500,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.sixthStep[2]))})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: -_vm.windowWidth,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.sixthStepTriggerAtPoint + 900,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.sixthStep[1]))})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: _vm.windowWidth,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.sixthStepTriggerAtPoint + 1300,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.sixthStep[3]))})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
          { // 0%
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 0,
            duration: 0
          },
          {
            translateX: 0,
            translateY: 0,
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 500
          }
        ],"triggerAt":_vm.sixthStepTriggerAtPoint + 1600,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + (_vm.sixthStep[4]))})},[_c('p',{staticClass:"sr-only"},[_vm._v("Not all components are what we call 'life-expired.' We can take them apart to recover parts and materials with life left in them. They are processed, checked, and go straight back into the railway!")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }